export function truncate(input: string, maxLengh: number) {
  if (input.length > maxLengh) {
    return input.substring(0, maxLengh) + '...'
  }
  return input
}

